export default __webpack_public_path__ + "static/media/tpaita3.823d57c1.webp";